import { configureStore } from '@reduxjs/toolkit';
import LoadingSlice from './loading';
import AuthSlice from './auth';

const defaultMiddlewareConfig = {
  serializableCheck: false
};

const store = configureStore({
  reducer: {
    loading: LoadingSlice.reducer,
    auth: AuthSlice.reducer
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(defaultMiddlewareConfig)
});

export const storeDispatch = store.dispatch;

export { store };
export default store;